module.exports = __webpack_public_path__ + "img/yingbi13.2e535b11.png";